<template>
    <div>
        <!-- v-menu with activator -->
        <v-menu v-model="drawer" start offset-y offset-x  >
            <template v-slot:activator="{ props }">
                <v-btn v-bind="props" @click="toggleDrawer" class="primary-new-button p-2">
                    <v-icon>mdi-menu</v-icon>
                </v-btn>
            </template>

            <v-list dense style="min-width: 150px;">
                <!-- Inbox Menu Item -->
                <v-list-item :to="{ name: 'inbox' }" @click="navigateTo('inbox')" class="menu-item"
                    :class="{ 'menu-item--active': $route.name === 'inbox' }" >
                    <v-list-item-content>
                        <div class="d-flex gap-2 align-center justify-center">
                            <v-icon>mdi-email-outline</v-icon>
                          {{ $t("res_TabsName_Inbox") }}
                        </div>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item :to="{ name: 'signed' }" @click="navigateTo('signed')" class="menu-item"
                    :class="{ 'menu-item--active': $route.name === 'signed' }">
                <v-list-item-content>
                        <div class="d-flex gap-2 align-center justify-center">
        
                            <v-icon>mdi-signature-freehand</v-icon>
                        {{ $t('res_Label_Signed') }}
                        </div>
                    </v-list-item-content>
                </v-list-item>

                <!-- Profile Menu Item -->
                <v-list-item :to="{ name: 'profile' }" @click="navigateTo('profile')" class="menu-item"
                    :class="{ 'menu-item--active': $route.name === 'profile' }">
                   
                    <v-list-item-content>
                        <div class="d-flex gap-2 align-center justify-center">
                            <v-icon>mdi-account</v-icon>
                        Profile
                        </div>
                    </v-list-item-content>
                </v-list-item>

                <!-- Logout Menu Item -->
                <v-list-item @click="logout" class="menu-item">
                  
                    <v-list-item-content>
                            <div class="d-flex gap-2 align-center justify-center">

                        <v-icon>mdi-logout</v-icon>
                       Logout
                        </div>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
import axios from 'axios'
import UserSignatureManager from '../components/UserSignatureManager.vue'
import { mapGetters, mapActions } from 'vuex'
import draggable from "vuedraggable"
import * as utils from '../assets/js/common.js'
import MessagesUtil from '@/utils/messagesUtil'

export default {
    name: 'Menu',
    components: {
        UserSignatureManager,
         draggable, UserSignatureManager
    },
    data() {
        return {
            drawer: false,
            isPermanent: false,  // Adjust if you want the menu to be permanent on larger screens
            isRtl: false
        };
    },
    methods: {
        navigateTo(routeName) {
            if (this.$route.path !== '/'+routeName) {
                  this.$router.push({ name: routeName });
            }else{
                window.location.reload();
            }
        },
        logout() {
            // Clear the token and redirect to login
            localStorage.removeItem('user');
            this.$router.push({ name: 'login' });
            window.location.reload();
        },
        closeDrawer() {
            this.drawer = false; // Close the drawer when clicking outside
        },
        toggleDrawer() {
            this.drawer = !this.drawer; // Toggle the drawer visibility
        },
    }
};
</script>

<style scoped>



.v-rtl {
    direction: rtl;
}





</style>
